module.exports = __webpack_public_path__ + "img/Number=19.4a6342c2.png";